module.exports = __webpack_public_path__ + "static/media/logo.b1da410e.svg";